import { cva } from "components/lib";

const buttonVariants = cva(
  `inline-flex items-center justify-center whitespace-nowrap rounded-md 
   font-medium ring-offset-white transition-colors 
   focus-visible:outline-none 
   focus-visible:ring-2 
   focus-visible:ring-slate-200 
   focus-visible:ring-offset-2 
   disabled:pointer-events-none 
   disabled:opacity-50 
   dark:ring-offset-slate-200 
   dark:focus-visible:ring-slate-300 relative`,

  {
    variants: {
      variant: {
        default: `relative bg-slate-900 text-slate-50 hover:bg-slate-900/90 
           dark:bg-slate-50 dark:text-slate-900 dark:hover:bg-slate-50/90`,
        theme: `relative bg-[#605BFF] text-white hover:bg-slate-900/90 
           dark:bg-slate-50 dark:text-slate-900 dark:hover:bg-slate-50/90`,
        destructive: `bg-red-500 text-slate-50 hover:bg-red-500/90 dark:bg-red-700 
           dark:text-slate-50 dark:hover:bg-red-700/90`,
        outline: `border border-white/20 text-white bg-white/5 backdrop-blur-md hover:bg-white/10
           hover:text-white font-light tracking-wide rounded-[10px] text-[16px] shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105`,
        ghost: `hover:bg-slate-100 hover:text-slate-900 dark:hover:bg-slate-700 
           dark:hover:text-slate-50`,
        icon: "!w-5 !h-5 rounded-none",
        link: "text-slate-900 underline-offset-4 h-auto hover:underline dark:text-slate-50",
        rounded: `bg-slate-900 text-slate-50 hover:bg-slate-900/90 dark:bg-slate-50 
           dark:text-slate-900 dark:hover:bg-slate-50/90 rounded-full`,
        naked: `!hover:text-inherit !focus-visible:outline-none !focus-visible:ring-0 
          !p-0 !m-0 !h-auto !rounded-none !font-normal !text-base !leading-normal`,
      },
      size: {
        default: `h-14 px-4 py-2`,
        xs: "h-7 rounded-md px-3",
        sm: `h-9 rounded-md px-3`,
        lg: `h-11 rounded-md px-8`,
        full: "h-14 !w-full",
        icon: "h-12 w-12",
      },
      color: {
        red: "bg-red-500 hover:bg-red-500/90 dark:bg-red-500 dark:text-white dark:hover:bg-red-500/90",

        blue: "bg-blue-500 hover:bg-blue-500/90 dark:bg-blue-500 dark:text-white dark:hover:bg-blue-500/90",

        green:
          "bg-emerald-500 hover:bg-emerald-500/90 dark:bg-emerald-5000 dark:text-white dark:hover:bg-emerald-500/90",

        orange:
          "bg-orange-500 hover:bg-orange-500/90 dark:bg-orange-500 dark:text-white dark:hover:bg-orange-500/90",

        primary:
          "bg-gradient-to-r from-blue-500 to-blue-600 text-white font-light tracking-wide border-0 rounded-[10px] text-[16px] shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 hover:brightness-110",
        
        glass:
          "glass-button text-white font-light tracking-wide border border-white/20 rounded-xl text-[16px] shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 backdrop-blur-md",
        
        glassBlue:
          "glass-button text-white font-light tracking-wide border border-blue-400/30 rounded-xl text-[16px] shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 backdrop-blur-md bg-blue-500/10 hover:bg-blue-500/20",
        
        glassGreen:
          "glass-button text-white font-light tracking-wide border border-emerald-400/30 rounded-xl text-[16px] shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 backdrop-blur-md bg-emerald-500/10 hover:bg-emerald-500/20",
        
        glassPurple:
          "glass-button text-white font-light tracking-wide border border-purple-400/30 rounded-xl text-[16px] shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 backdrop-blur-md bg-purple-500/10 hover:bg-purple-500/20",
        
        glassOrange:
          "glass-button text-white font-light tracking-wide border border-orange-400/30 rounded-xl text-[16px] shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 backdrop-blur-md bg-orange-500/10 hover:bg-orange-500/20",
        
        glassPink:
          "glass-button text-white font-light tracking-wide border border-pink-400/30 rounded-xl text-[16px] shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 backdrop-blur-md bg-pink-500/10 hover:bg-pink-500/20",
      },
    },
    defaultVariants: {
      variant: `default`,
      size: `default`,
    },
  }
);

export default buttonVariants;
